module.exports = __webpack_public_path__ + "static/img/zt4.b750ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/zt4.png
// module id = 308
// module chunks = 34